import './Footer.css';
import {Link} from "react-router-dom";

function Footer() {
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <Link className="footer-link" to="/impressum" aria-label="Impressum Seite">Impressum</Link>
                <Link className="footer-link" to="/datenschutz" aria-label="Datenschutz Seite">Datenschutz</Link>
                <Link className="footer-link" to="/barrierefreiheit" aria-label="Erklärung zur Barrierefreiheit">Erklärung
                    zur Barrierefreiheit</Link>
            </div>
        </footer>
    );
}

export default Footer;
